module.exports = __webpack_public_path__ + "images/rolex_buyback_trend/crown_7dda69c4bb7b984af15b4873b73b3844.svg";